/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.3.0 (NJsonSchema v10.4.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ClientBase } from './client-base';
import { JwtHolder } from './jwt-holder';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AuthorizerClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<AuthorizerDto> {
        let url_ = this.baseUrl + "/api/Authorizer/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AuthorizerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthorizerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizerDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<AuthorizerDto[]> {
        let url_ = this.baseUrl + "/api/Authorizer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AuthorizerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorizerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizerDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CreateAuthorizerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorizer/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AuthorizerUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorizer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Authorizer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CardTypeClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<PaymentTypeDto> {
        let url_ = this.baseUrl + "/api/CardType/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<PaymentTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PaymentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentTypeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<PaymentTypeDto[]> {
        let url_ = this.baseUrl + "/api/CardType/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PaymentTypeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentTypeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaymentTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentTypeDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CreatePaymentTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CardType/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PaymentTypeUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CardType/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CardType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class CardTypeRangeClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<CardTypeRangeDto> {
        let url_ = this.baseUrl + "/api/CardTypeRange/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<CardTypeRangeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardTypeRangeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CardTypeRangeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CardTypeRangeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTypeRangeDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<CardTypeRangeDto[]> {
        let url_ = this.baseUrl + "/api/CardTypeRange/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<CardTypeRangeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CardTypeRangeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CardTypeRangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CardTypeRangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CardTypeRangeDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CreateCardTypeRangeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CardTypeRange/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CardTypeRangeUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CardTypeRange/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/CardTypeRange/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FraudScreenerClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<FraudScreenerDto> {
        let url_ = this.baseUrl + "/api/FraudScreener/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<FraudScreenerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FraudScreenerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FraudScreenerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FraudScreenerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FraudScreenerDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<FraudScreenerDto[]> {
        let url_ = this.baseUrl + "/api/FraudScreener/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<FraudScreenerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FraudScreenerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FraudScreenerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FraudScreenerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FraudScreenerDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CreateFraudScreenerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FraudScreener/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FraudScreenerUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FraudScreener/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FraudScreener/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class LoginClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginDto | undefined): Observable<AuthenticationToken> {
        let url_ = this.baseUrl + "/api/Login/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticationToken>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticationToken>><any>_observableThrow(response_);
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AuthenticationToken> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticationToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticationToken>(<any>null);
    }

    /**
     * @return Success
     */
    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/Login/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class RoutingRulesClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param countryCode (optional) 
     * @param currencyCode (optional) 
     * @return Success
     */
    getById(id: number, countryCode: string | null | undefined, currencyCode: string | null | undefined): Observable<RoutingRulesDto> {
        let url_ = this.baseUrl + "/api/RoutingRules/GetById/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (currencyCode !== undefined && currencyCode !== null)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<RoutingRulesDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoutingRulesDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<RoutingRulesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoutingRulesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoutingRulesDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<RoutingRulesDto[]> {
        let url_ = this.baseUrl + "/api/RoutingRules/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<RoutingRulesDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoutingRulesDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoutingRulesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoutingRulesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoutingRulesDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CreateRoutingRulesDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RoutingRules/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoutingRulesUpdateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RoutingRules/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param countryCode (optional) 
     * @param currencyCode (optional) 
     * @return Success
     */
    delete(id: number | undefined, countryCode: string | null | undefined, currencyCode: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RoutingRules/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (currencyCode !== undefined && currencyCode !== null)
            url_ += "currencyCode=" + encodeURIComponent("" + currencyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SystemCustomerClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getById(id: number): Observable<SystemCustomerDto> {
        let url_ = this.baseUrl + "/api/SystemCustomer/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(<any>response_);
                } catch (e) {
                    return <Observable<SystemCustomerDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemCustomerDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SystemCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemCustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemCustomerDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAll(): Observable<SystemCustomerDto[]> {
        let url_ = this.baseUrl + "/api/SystemCustomer/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<SystemCustomerDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SystemCustomerDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SystemCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemCustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SystemCustomerDto[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    insert(body: CreateSystemCustomerDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SystemCustomer/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/SystemCustomer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class TransactionClient extends ClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(JwtHolder) configuration: JwtHolder, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param typeFilter (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    getTransactionsDataTable(typeFilter: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, body: DatatableParameters | undefined): Observable<DataTableResponse> {
        let url_ = this.baseUrl + "/api/Transaction/GetTransactionsDataTable?";
        if (typeFilter !== undefined && typeFilter !== null)
            url_ += "typeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsDataTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsDataTable(<any>response_);
                } catch (e) {
                    return <Observable<DataTableResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<DataTableResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionsDataTable(response: HttpResponseBase): Observable<DataTableResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataTableResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DataTableResponse>(<any>null);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param typeFilter (optional) 
     * @param filter (optional) 
     * @return Success
     */
    download(startDate: string | null | undefined, endDate: string | null | undefined, typeFilter: string | null | undefined, filter: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Transaction/Download?";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (typeFilter !== undefined && typeFilter !== null)
            url_ += "typeFilter=" + encodeURIComponent("" + typeFilter) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class AuthorizerDto implements IAuthorizerDto {
    id?: number;
    name?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;

    constructor(data?: IAuthorizerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.serviceUrl = _data["serviceUrl"] !== undefined ? _data["serviceUrl"] : <any>null;
            this.assemblyName = _data["assemblyName"] !== undefined ? _data["assemblyName"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): AuthorizerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["serviceUrl"] = this.serviceUrl !== undefined ? this.serviceUrl : <any>null;
        data["assemblyName"] = this.assemblyName !== undefined ? this.assemblyName : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface IAuthorizerDto {
    id?: number;
    name?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;
}

export class CreateAuthorizerDto implements ICreateAuthorizerDto {
    name?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;

    constructor(data?: ICreateAuthorizerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.serviceUrl = _data["serviceUrl"] !== undefined ? _data["serviceUrl"] : <any>null;
            this.assemblyName = _data["assemblyName"] !== undefined ? _data["assemblyName"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateAuthorizerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAuthorizerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["serviceUrl"] = this.serviceUrl !== undefined ? this.serviceUrl : <any>null;
        data["assemblyName"] = this.assemblyName !== undefined ? this.assemblyName : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface ICreateAuthorizerDto {
    name?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;
}

export class AuthorizerUpdateDto implements IAuthorizerUpdateDto {
    id?: number;
    name?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;

    constructor(data?: IAuthorizerUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.serviceUrl = _data["serviceUrl"] !== undefined ? _data["serviceUrl"] : <any>null;
            this.assemblyName = _data["assemblyName"] !== undefined ? _data["assemblyName"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): AuthorizerUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizerUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["serviceUrl"] = this.serviceUrl !== undefined ? this.serviceUrl : <any>null;
        data["assemblyName"] = this.assemblyName !== undefined ? this.assemblyName : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface IAuthorizerUpdateDto {
    id?: number;
    name?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;
}

export enum CardTypeEnum {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PaymentTypeDto implements IPaymentTypeDto {
    id?: number;
    name?: string | null;
    cardType?: CardTypeEnum;
    paymentMethodCode?: string | null;

    constructor(data?: IPaymentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.cardType = _data["cardType"] !== undefined ? _data["cardType"] : <any>null;
            this.paymentMethodCode = _data["paymentMethodCode"] !== undefined ? _data["paymentMethodCode"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["cardType"] = this.cardType !== undefined ? this.cardType : <any>null;
        data["paymentMethodCode"] = this.paymentMethodCode !== undefined ? this.paymentMethodCode : <any>null;
        return data; 
    }
}

export interface IPaymentTypeDto {
    id?: number;
    name?: string | null;
    cardType?: CardTypeEnum;
    paymentMethodCode?: string | null;
}

export class CreatePaymentTypeDto implements ICreatePaymentTypeDto {
    name?: string | null;
    cardType?: CardTypeEnum;
    paymentMethodCode?: string | null;

    constructor(data?: ICreatePaymentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.cardType = _data["cardType"] !== undefined ? _data["cardType"] : <any>null;
            this.paymentMethodCode = _data["paymentMethodCode"] !== undefined ? _data["paymentMethodCode"] : <any>null;
        }
    }

    static fromJS(data: any): CreatePaymentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["cardType"] = this.cardType !== undefined ? this.cardType : <any>null;
        data["paymentMethodCode"] = this.paymentMethodCode !== undefined ? this.paymentMethodCode : <any>null;
        return data; 
    }
}

export interface ICreatePaymentTypeDto {
    name?: string | null;
    cardType?: CardTypeEnum;
    paymentMethodCode?: string | null;
}

export class PaymentTypeUpdateDto implements IPaymentTypeUpdateDto {
    id?: number;
    name?: string | null;
    cardType?: CardTypeEnum;
    paymentMethodCode?: string | null;

    constructor(data?: IPaymentTypeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.cardType = _data["cardType"] !== undefined ? _data["cardType"] : <any>null;
            this.paymentMethodCode = _data["paymentMethodCode"] !== undefined ? _data["paymentMethodCode"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentTypeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["cardType"] = this.cardType !== undefined ? this.cardType : <any>null;
        data["paymentMethodCode"] = this.paymentMethodCode !== undefined ? this.paymentMethodCode : <any>null;
        return data; 
    }
}

export interface IPaymentTypeUpdateDto {
    id?: number;
    name?: string | null;
    cardType?: CardTypeEnum;
    paymentMethodCode?: string | null;
}

export class CardTypeRangeDto implements ICardTypeRangeDto {
    id?: number;
    paymentTypeId?: number;
    initialRange?: number;
    finalRange?: number;

    constructor(data?: ICardTypeRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.paymentTypeId = _data["paymentTypeId"] !== undefined ? _data["paymentTypeId"] : <any>null;
            this.initialRange = _data["initialRange"] !== undefined ? _data["initialRange"] : <any>null;
            this.finalRange = _data["finalRange"] !== undefined ? _data["finalRange"] : <any>null;
        }
    }

    static fromJS(data: any): CardTypeRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTypeRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["paymentTypeId"] = this.paymentTypeId !== undefined ? this.paymentTypeId : <any>null;
        data["initialRange"] = this.initialRange !== undefined ? this.initialRange : <any>null;
        data["finalRange"] = this.finalRange !== undefined ? this.finalRange : <any>null;
        return data; 
    }
}

export interface ICardTypeRangeDto {
    id?: number;
    paymentTypeId?: number;
    initialRange?: number;
    finalRange?: number;
}

export class CreateCardTypeRangeDto implements ICreateCardTypeRangeDto {
    paymentTypeId?: number;
    initialRange?: number;
    finalRange?: number;

    constructor(data?: ICreateCardTypeRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentTypeId = _data["paymentTypeId"] !== undefined ? _data["paymentTypeId"] : <any>null;
            this.initialRange = _data["initialRange"] !== undefined ? _data["initialRange"] : <any>null;
            this.finalRange = _data["finalRange"] !== undefined ? _data["finalRange"] : <any>null;
        }
    }

    static fromJS(data: any): CreateCardTypeRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCardTypeRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentTypeId"] = this.paymentTypeId !== undefined ? this.paymentTypeId : <any>null;
        data["initialRange"] = this.initialRange !== undefined ? this.initialRange : <any>null;
        data["finalRange"] = this.finalRange !== undefined ? this.finalRange : <any>null;
        return data; 
    }
}

export interface ICreateCardTypeRangeDto {
    paymentTypeId?: number;
    initialRange?: number;
    finalRange?: number;
}

export class CardTypeRangeUpdateDto implements ICardTypeRangeUpdateDto {
    id?: number;
    paymentTypeId?: number;
    initialRange?: number;
    finalRange?: number;

    constructor(data?: ICardTypeRangeUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.paymentTypeId = _data["paymentTypeId"] !== undefined ? _data["paymentTypeId"] : <any>null;
            this.initialRange = _data["initialRange"] !== undefined ? _data["initialRange"] : <any>null;
            this.finalRange = _data["finalRange"] !== undefined ? _data["finalRange"] : <any>null;
        }
    }

    static fromJS(data: any): CardTypeRangeUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CardTypeRangeUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["paymentTypeId"] = this.paymentTypeId !== undefined ? this.paymentTypeId : <any>null;
        data["initialRange"] = this.initialRange !== undefined ? this.initialRange : <any>null;
        data["finalRange"] = this.finalRange !== undefined ? this.finalRange : <any>null;
        return data; 
    }
}

export interface ICardTypeRangeUpdateDto {
    id?: number;
    paymentTypeId?: number;
    initialRange?: number;
    finalRange?: number;
}

export class FraudScreenerDto implements IFraudScreenerDto {
    id?: number;
    description?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;

    constructor(data?: IFraudScreenerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.serviceUrl = _data["serviceUrl"] !== undefined ? _data["serviceUrl"] : <any>null;
            this.assemblyName = _data["assemblyName"] !== undefined ? _data["assemblyName"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): FraudScreenerDto {
        data = typeof data === 'object' ? data : {};
        let result = new FraudScreenerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["serviceUrl"] = this.serviceUrl !== undefined ? this.serviceUrl : <any>null;
        data["assemblyName"] = this.assemblyName !== undefined ? this.assemblyName : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface IFraudScreenerDto {
    id?: number;
    description?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;
}

export class CreateFraudScreenerDto implements ICreateFraudScreenerDto {
    description?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;

    constructor(data?: ICreateFraudScreenerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.serviceUrl = _data["serviceUrl"] !== undefined ? _data["serviceUrl"] : <any>null;
            this.assemblyName = _data["assemblyName"] !== undefined ? _data["assemblyName"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateFraudScreenerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFraudScreenerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["serviceUrl"] = this.serviceUrl !== undefined ? this.serviceUrl : <any>null;
        data["assemblyName"] = this.assemblyName !== undefined ? this.assemblyName : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface ICreateFraudScreenerDto {
    description?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;
}

export class FraudScreenerUpdateDto implements IFraudScreenerUpdateDto {
    id?: number;
    description?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;

    constructor(data?: IFraudScreenerUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.serviceUrl = _data["serviceUrl"] !== undefined ? _data["serviceUrl"] : <any>null;
            this.assemblyName = _data["assemblyName"] !== undefined ? _data["assemblyName"] : <any>null;
            this.typeName = _data["typeName"] !== undefined ? _data["typeName"] : <any>null;
        }
    }

    static fromJS(data: any): FraudScreenerUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FraudScreenerUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["serviceUrl"] = this.serviceUrl !== undefined ? this.serviceUrl : <any>null;
        data["assemblyName"] = this.assemblyName !== undefined ? this.assemblyName : <any>null;
        data["typeName"] = this.typeName !== undefined ? this.typeName : <any>null;
        return data; 
    }
}

export interface IFraudScreenerUpdateDto {
    id?: number;
    description?: string | null;
    serviceUrl?: string | null;
    assemblyName?: string | null;
    typeName?: string | null;
}

export class LoginDto implements ILoginDto {
    domainCode?: string | null;
    agentName?: string | null;
    passWord?: string | null;

    constructor(data?: ILoginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainCode = _data["domainCode"] !== undefined ? _data["domainCode"] : <any>null;
            this.agentName = _data["agentName"] !== undefined ? _data["agentName"] : <any>null;
            this.passWord = _data["passWord"] !== undefined ? _data["passWord"] : <any>null;
        }
    }

    static fromJS(data: any): LoginDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainCode"] = this.domainCode !== undefined ? this.domainCode : <any>null;
        data["agentName"] = this.agentName !== undefined ? this.agentName : <any>null;
        data["passWord"] = this.passWord !== undefined ? this.passWord : <any>null;
        return data; 
    }
}

export interface ILoginDto {
    domainCode?: string | null;
    agentName?: string | null;
    passWord?: string | null;
}

export class AuthenticationToken implements IAuthenticationToken {
    accessToken?: string | null;
    creation?: Date;
    expiration?: Date;

    constructor(data?: IAuthenticationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.creation = _data["creation"] ? new Date(_data["creation"].toString()) : <any>null;
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AuthenticationToken {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["creation"] = this.creation ? this.creation.toISOString() : <any>null;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>null;
        return data; 
    }
}

export interface IAuthenticationToken {
    accessToken?: string | null;
    creation?: Date;
    expiration?: Date;
}

export class RoutingRulesDto implements IRoutingRulesDto {
    cardTypeId?: number;
    cardTypeName?: string | null;
    countryCode?: string | null;
    currencyCode?: string | null;
    authorizerId?: number;
    authorizerName?: string | null;
    fraudScreenerId?: number | null;
    fraudScreenerName?: string | null;

    constructor(data?: IRoutingRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardTypeId = _data["cardTypeId"] !== undefined ? _data["cardTypeId"] : <any>null;
            this.cardTypeName = _data["cardTypeName"] !== undefined ? _data["cardTypeName"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : <any>null;
            this.authorizerId = _data["authorizerId"] !== undefined ? _data["authorizerId"] : <any>null;
            this.authorizerName = _data["authorizerName"] !== undefined ? _data["authorizerName"] : <any>null;
            this.fraudScreenerId = _data["fraudScreenerId"] !== undefined ? _data["fraudScreenerId"] : <any>null;
            this.fraudScreenerName = _data["fraudScreenerName"] !== undefined ? _data["fraudScreenerName"] : <any>null;
        }
    }

    static fromJS(data: any): RoutingRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoutingRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTypeId"] = this.cardTypeId !== undefined ? this.cardTypeId : <any>null;
        data["cardTypeName"] = this.cardTypeName !== undefined ? this.cardTypeName : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : <any>null;
        data["authorizerId"] = this.authorizerId !== undefined ? this.authorizerId : <any>null;
        data["authorizerName"] = this.authorizerName !== undefined ? this.authorizerName : <any>null;
        data["fraudScreenerId"] = this.fraudScreenerId !== undefined ? this.fraudScreenerId : <any>null;
        data["fraudScreenerName"] = this.fraudScreenerName !== undefined ? this.fraudScreenerName : <any>null;
        return data; 
    }
}

export interface IRoutingRulesDto {
    cardTypeId?: number;
    cardTypeName?: string | null;
    countryCode?: string | null;
    currencyCode?: string | null;
    authorizerId?: number;
    authorizerName?: string | null;
    fraudScreenerId?: number | null;
    fraudScreenerName?: string | null;
}

export class CreateRoutingRulesDto implements ICreateRoutingRulesDto {
    cardTypeId?: number;
    countryCode?: string | null;
    currencyCode?: string | null;
    authorizerId?: number;
    fraudScreenerId?: number | null;

    constructor(data?: ICreateRoutingRulesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardTypeId = _data["cardTypeId"] !== undefined ? _data["cardTypeId"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : <any>null;
            this.authorizerId = _data["authorizerId"] !== undefined ? _data["authorizerId"] : <any>null;
            this.fraudScreenerId = _data["fraudScreenerId"] !== undefined ? _data["fraudScreenerId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateRoutingRulesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoutingRulesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTypeId"] = this.cardTypeId !== undefined ? this.cardTypeId : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : <any>null;
        data["authorizerId"] = this.authorizerId !== undefined ? this.authorizerId : <any>null;
        data["fraudScreenerId"] = this.fraudScreenerId !== undefined ? this.fraudScreenerId : <any>null;
        return data; 
    }
}

export interface ICreateRoutingRulesDto {
    cardTypeId?: number;
    countryCode?: string | null;
    currencyCode?: string | null;
    authorizerId?: number;
    fraudScreenerId?: number | null;
}

export class RoutingRulesUpdateDto implements IRoutingRulesUpdateDto {
    cardTypeId?: number;
    countryCode?: string | null;
    currencyCode?: string | null;
    authorizerId?: number;
    fraudScreenerId?: number | null;

    constructor(data?: IRoutingRulesUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardTypeId = _data["cardTypeId"] !== undefined ? _data["cardTypeId"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : <any>null;
            this.authorizerId = _data["authorizerId"] !== undefined ? _data["authorizerId"] : <any>null;
            this.fraudScreenerId = _data["fraudScreenerId"] !== undefined ? _data["fraudScreenerId"] : <any>null;
        }
    }

    static fromJS(data: any): RoutingRulesUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoutingRulesUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardTypeId"] = this.cardTypeId !== undefined ? this.cardTypeId : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : <any>null;
        data["authorizerId"] = this.authorizerId !== undefined ? this.authorizerId : <any>null;
        data["fraudScreenerId"] = this.fraudScreenerId !== undefined ? this.fraudScreenerId : <any>null;
        return data; 
    }
}

export interface IRoutingRulesUpdateDto {
    cardTypeId?: number;
    countryCode?: string | null;
    currencyCode?: string | null;
    authorizerId?: number;
    fraudScreenerId?: number | null;
}

export class SystemCustomerDto implements ISystemCustomerDto {
    id?: number;
    name?: string | null;
    callBackServiceUrl?: string | null;

    constructor(data?: ISystemCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.callBackServiceUrl = _data["callBackServiceUrl"] !== undefined ? _data["callBackServiceUrl"] : <any>null;
        }
    }

    static fromJS(data: any): SystemCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["callBackServiceUrl"] = this.callBackServiceUrl !== undefined ? this.callBackServiceUrl : <any>null;
        return data; 
    }
}

export interface ISystemCustomerDto {
    id?: number;
    name?: string | null;
    callBackServiceUrl?: string | null;
}

export class CreateSystemCustomerDto implements ICreateSystemCustomerDto {
    name?: string | null;
    callBackServiceUrl?: string | null;

    constructor(data?: ICreateSystemCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.callBackServiceUrl = _data["callBackServiceUrl"] !== undefined ? _data["callBackServiceUrl"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSystemCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["callBackServiceUrl"] = this.callBackServiceUrl !== undefined ? this.callBackServiceUrl : <any>null;
        return data; 
    }
}

export interface ICreateSystemCustomerDto {
    name?: string | null;
    callBackServiceUrl?: string | null;
}

export class Search implements ISearch {
    value?: string | null;
    regex?: boolean;

    constructor(data?: ISearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.regex = _data["regex"] !== undefined ? _data["regex"] : <any>null;
        }
    }

    static fromJS(data: any): Search {
        data = typeof data === 'object' ? data : {};
        let result = new Search();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["regex"] = this.regex !== undefined ? this.regex : <any>null;
        return data; 
    }
}

export interface ISearch {
    value?: string | null;
    regex?: boolean;
}

export class Column implements IColumn {
    data?: string | null;
    name?: string | null;
    searchable?: boolean;
    orderable?: boolean;
    search?: Search;

    constructor(data?: IColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] !== undefined ? _data["data"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.searchable = _data["searchable"] !== undefined ? _data["searchable"] : <any>null;
            this.orderable = _data["orderable"] !== undefined ? _data["orderable"] : <any>null;
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : <any>null;
        }
    }

    static fromJS(data: any): Column {
        data = typeof data === 'object' ? data : {};
        let result = new Column();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["searchable"] = this.searchable !== undefined ? this.searchable : <any>null;
        data["orderable"] = this.orderable !== undefined ? this.orderable : <any>null;
        data["search"] = this.search ? this.search.toJSON() : <any>null;
        return data; 
    }
}

export interface IColumn {
    data?: string | null;
    name?: string | null;
    searchable?: boolean;
    orderable?: boolean;
    search?: Search;
}

export class Order implements IOrder {
    column?: number;
    dir?: string | null;

    constructor(data?: IOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.column = _data["column"] !== undefined ? _data["column"] : <any>null;
            this.dir = _data["dir"] !== undefined ? _data["dir"] : <any>null;
        }
    }

    static fromJS(data: any): Order {
        data = typeof data === 'object' ? data : {};
        let result = new Order();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["column"] = this.column !== undefined ? this.column : <any>null;
        data["dir"] = this.dir !== undefined ? this.dir : <any>null;
        return data; 
    }
}

export interface IOrder {
    column?: number;
    dir?: string | null;
}

export class DatatableParameters implements IDatatableParameters {
    draw?: number;
    columns?: Column[] | null;
    order?: Order[] | null;
    start?: number;
    length?: number;
    search?: Search;

    constructor(data?: IDatatableParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draw = _data["draw"] !== undefined ? _data["draw"] : <any>null;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(Column.fromJS(item));
            }
            else {
                this.columns = <any>null;
            }
            if (Array.isArray(_data["order"])) {
                this.order = [] as any;
                for (let item of _data["order"])
                    this.order!.push(Order.fromJS(item));
            }
            else {
                this.order = <any>null;
            }
            this.start = _data["start"] !== undefined ? _data["start"] : <any>null;
            this.length = _data["length"] !== undefined ? _data["length"] : <any>null;
            this.search = _data["search"] ? Search.fromJS(_data["search"]) : <any>null;
        }
    }

    static fromJS(data: any): DatatableParameters {
        data = typeof data === 'object' ? data : {};
        let result = new DatatableParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draw"] = this.draw !== undefined ? this.draw : <any>null;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        if (Array.isArray(this.order)) {
            data["order"] = [];
            for (let item of this.order)
                data["order"].push(item.toJSON());
        }
        data["start"] = this.start !== undefined ? this.start : <any>null;
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["search"] = this.search ? this.search.toJSON() : <any>null;
        return data; 
    }
}

export interface IDatatableParameters {
    draw?: number;
    columns?: Column[] | null;
    order?: Order[] | null;
    start?: number;
    length?: number;
    search?: Search;
}

export class TransactionDto implements ITransactionDto {
    id?: number;
    transactionParentId?: number | null;
    systemCustomerId?: number | null;
    requestCorrelationId?: string | null;
    productCorrelationId?: string | null;
    authorizerId?: number | null;
    authorizerName?: string | null;
    authorizerCorrelationId?: string | null;
    transactionType?: string | null;
    transactionStatus?: string | null;
    transactionCorrelationId?: string | null;
    transactionParentCorrelationId?: string | null;
    transactionDate?: string | null;
    transactionAmount?: number;
    paymentMethodCode?: string | null;
    countryCode?: string | null;
    currencyCode?: string | null;
    cardNumber?: string | null;
    cardHolderName?: string | null;
    expirationDate?: Date;
    instalments?: number;
    authorizationDate?: Date | null;
    authorizationCode?: string | null;
    authorizerDescription?: string | null;
    fraudScreenerId?: number | null;
    fraudScreenerName?: string | null;
    fraudCorrelationId?: string | null;
    fraudStatus?: string | null;
    fraudStatusDescription?: string | null;
    countryCodeRule?: string | null;
    currencyCodeRule?: string | null;
    retries?: number;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.transactionParentId = _data["transactionParentId"] !== undefined ? _data["transactionParentId"] : <any>null;
            this.systemCustomerId = _data["systemCustomerId"] !== undefined ? _data["systemCustomerId"] : <any>null;
            this.requestCorrelationId = _data["requestCorrelationId"] !== undefined ? _data["requestCorrelationId"] : <any>null;
            this.productCorrelationId = _data["productCorrelationId"] !== undefined ? _data["productCorrelationId"] : <any>null;
            this.authorizerId = _data["authorizerId"] !== undefined ? _data["authorizerId"] : <any>null;
            this.authorizerName = _data["authorizerName"] !== undefined ? _data["authorizerName"] : <any>null;
            this.authorizerCorrelationId = _data["authorizerCorrelationId"] !== undefined ? _data["authorizerCorrelationId"] : <any>null;
            this.transactionType = _data["transactionType"] !== undefined ? _data["transactionType"] : <any>null;
            this.transactionStatus = _data["transactionStatus"] !== undefined ? _data["transactionStatus"] : <any>null;
            this.transactionCorrelationId = _data["transactionCorrelationId"] !== undefined ? _data["transactionCorrelationId"] : <any>null;
            this.transactionParentCorrelationId = _data["transactionParentCorrelationId"] !== undefined ? _data["transactionParentCorrelationId"] : <any>null;
            this.transactionDate = _data["transactionDate"] !== undefined ? _data["transactionDate"] : <any>null;
            this.transactionAmount = _data["transactionAmount"] !== undefined ? _data["transactionAmount"] : <any>null;
            this.paymentMethodCode = _data["paymentMethodCode"] !== undefined ? _data["paymentMethodCode"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.currencyCode = _data["currencyCode"] !== undefined ? _data["currencyCode"] : <any>null;
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : <any>null;
            this.cardHolderName = _data["cardHolderName"] !== undefined ? _data["cardHolderName"] : <any>null;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>null;
            this.instalments = _data["instalments"] !== undefined ? _data["instalments"] : <any>null;
            this.authorizationDate = _data["authorizationDate"] ? new Date(_data["authorizationDate"].toString()) : <any>null;
            this.authorizationCode = _data["authorizationCode"] !== undefined ? _data["authorizationCode"] : <any>null;
            this.authorizerDescription = _data["authorizerDescription"] !== undefined ? _data["authorizerDescription"] : <any>null;
            this.fraudScreenerId = _data["fraudScreenerId"] !== undefined ? _data["fraudScreenerId"] : <any>null;
            this.fraudScreenerName = _data["fraudScreenerName"] !== undefined ? _data["fraudScreenerName"] : <any>null;
            this.fraudCorrelationId = _data["fraudCorrelationId"] !== undefined ? _data["fraudCorrelationId"] : <any>null;
            this.fraudStatus = _data["fraudStatus"] !== undefined ? _data["fraudStatus"] : <any>null;
            this.fraudStatusDescription = _data["fraudStatusDescription"] !== undefined ? _data["fraudStatusDescription"] : <any>null;
            this.countryCodeRule = _data["countryCodeRule"] !== undefined ? _data["countryCodeRule"] : <any>null;
            this.currencyCodeRule = _data["currencyCodeRule"] !== undefined ? _data["currencyCodeRule"] : <any>null;
            this.retries = _data["retries"] !== undefined ? _data["retries"] : <any>null;
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["transactionParentId"] = this.transactionParentId !== undefined ? this.transactionParentId : <any>null;
        data["systemCustomerId"] = this.systemCustomerId !== undefined ? this.systemCustomerId : <any>null;
        data["requestCorrelationId"] = this.requestCorrelationId !== undefined ? this.requestCorrelationId : <any>null;
        data["productCorrelationId"] = this.productCorrelationId !== undefined ? this.productCorrelationId : <any>null;
        data["authorizerId"] = this.authorizerId !== undefined ? this.authorizerId : <any>null;
        data["authorizerName"] = this.authorizerName !== undefined ? this.authorizerName : <any>null;
        data["authorizerCorrelationId"] = this.authorizerCorrelationId !== undefined ? this.authorizerCorrelationId : <any>null;
        data["transactionType"] = this.transactionType !== undefined ? this.transactionType : <any>null;
        data["transactionStatus"] = this.transactionStatus !== undefined ? this.transactionStatus : <any>null;
        data["transactionCorrelationId"] = this.transactionCorrelationId !== undefined ? this.transactionCorrelationId : <any>null;
        data["transactionParentCorrelationId"] = this.transactionParentCorrelationId !== undefined ? this.transactionParentCorrelationId : <any>null;
        data["transactionDate"] = this.transactionDate !== undefined ? this.transactionDate : <any>null;
        data["transactionAmount"] = this.transactionAmount !== undefined ? this.transactionAmount : <any>null;
        data["paymentMethodCode"] = this.paymentMethodCode !== undefined ? this.paymentMethodCode : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["currencyCode"] = this.currencyCode !== undefined ? this.currencyCode : <any>null;
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["cardHolderName"] = this.cardHolderName !== undefined ? this.cardHolderName : <any>null;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>null;
        data["instalments"] = this.instalments !== undefined ? this.instalments : <any>null;
        data["authorizationDate"] = this.authorizationDate ? this.authorizationDate.toISOString() : <any>null;
        data["authorizationCode"] = this.authorizationCode !== undefined ? this.authorizationCode : <any>null;
        data["authorizerDescription"] = this.authorizerDescription !== undefined ? this.authorizerDescription : <any>null;
        data["fraudScreenerId"] = this.fraudScreenerId !== undefined ? this.fraudScreenerId : <any>null;
        data["fraudScreenerName"] = this.fraudScreenerName !== undefined ? this.fraudScreenerName : <any>null;
        data["fraudCorrelationId"] = this.fraudCorrelationId !== undefined ? this.fraudCorrelationId : <any>null;
        data["fraudStatus"] = this.fraudStatus !== undefined ? this.fraudStatus : <any>null;
        data["fraudStatusDescription"] = this.fraudStatusDescription !== undefined ? this.fraudStatusDescription : <any>null;
        data["countryCodeRule"] = this.countryCodeRule !== undefined ? this.countryCodeRule : <any>null;
        data["currencyCodeRule"] = this.currencyCodeRule !== undefined ? this.currencyCodeRule : <any>null;
        data["retries"] = this.retries !== undefined ? this.retries : <any>null;
        return data; 
    }
}

export interface ITransactionDto {
    id?: number;
    transactionParentId?: number | null;
    systemCustomerId?: number | null;
    requestCorrelationId?: string | null;
    productCorrelationId?: string | null;
    authorizerId?: number | null;
    authorizerName?: string | null;
    authorizerCorrelationId?: string | null;
    transactionType?: string | null;
    transactionStatus?: string | null;
    transactionCorrelationId?: string | null;
    transactionParentCorrelationId?: string | null;
    transactionDate?: string | null;
    transactionAmount?: number;
    paymentMethodCode?: string | null;
    countryCode?: string | null;
    currencyCode?: string | null;
    cardNumber?: string | null;
    cardHolderName?: string | null;
    expirationDate?: Date;
    instalments?: number;
    authorizationDate?: Date | null;
    authorizationCode?: string | null;
    authorizerDescription?: string | null;
    fraudScreenerId?: number | null;
    fraudScreenerName?: string | null;
    fraudCorrelationId?: string | null;
    fraudStatus?: string | null;
    fraudStatusDescription?: string | null;
    countryCodeRule?: string | null;
    currencyCodeRule?: string | null;
    retries?: number;
}

export class DataTableResponse implements IDataTableResponse {
    draw?: number;
    recordsTotal?: number;
    recordsFiltered?: number;
    filter?: string | null;
    data?: TransactionDto[] | null;

    constructor(data?: IDataTableResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.draw = _data["draw"] !== undefined ? _data["draw"] : <any>null;
            this.recordsTotal = _data["recordsTotal"] !== undefined ? _data["recordsTotal"] : <any>null;
            this.recordsFiltered = _data["recordsFiltered"] !== undefined ? _data["recordsFiltered"] : <any>null;
            this.filter = _data["filter"] !== undefined ? _data["filter"] : <any>null;
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TransactionDto.fromJS(item));
            }
            else {
                this.data = <any>null;
            }
        }
    }

    static fromJS(data: any): DataTableResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataTableResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["draw"] = this.draw !== undefined ? this.draw : <any>null;
        data["recordsTotal"] = this.recordsTotal !== undefined ? this.recordsTotal : <any>null;
        data["recordsFiltered"] = this.recordsFiltered !== undefined ? this.recordsFiltered : <any>null;
        data["filter"] = this.filter !== undefined ? this.filter : <any>null;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDataTableResponse {
    draw?: number;
    recordsTotal?: number;
    recordsFiltered?: number;
    filter?: string | null;
    data?: TransactionDto[] | null;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}